import React from 'react';
import { Navigate, Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { ROUTE, TOP_LEVEL_CATEGORY_ID } from 'app/constants/AdminBrowseConstants';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { makeHomeListPageRoute } from 'app/helpers/admin/browse/home';
import AdminBrowseCategoriesCreatePageRoute from './AdminBrowseCategoriesCreatePageRoute';
import AdminBrowseCategoriesEditPageRoute from './AdminBrowseCategoriesEditPageRoute';
import AdminBrowseCategoriesListPageRoute from './AdminBrowseCategoriesListPageRoute';
import AdminBrowseHomeCreatePageRoute from './AdminBrowseHomeCreatePageRoute';
import AdminBrowseHomeEditPageRoute from './AdminBrowseHomeEditPageRoute';
import AdminBrowseHomeListPageRoute from './AdminBrowseHomeListPageRoute';
import AdminBrowseHomePreviewPageRoute from './AdminBrowseHomePreviewPageRoute';

const DEFAULT_TOP_LEVEL_CATEGORY_ID = TOP_LEVEL_CATEGORY_ID.COLLECTION;

export default (
  <Route
    path={ROUTE.ADMIN}
    element={
      <MainLayout>
        <Outlet />
      </MainLayout>
    }
  >
    <Route path={ROUTE.ADMIN_BROWSE} element={<Navigate replace to={makeHomeListPageRoute('')} />} />

    {/* ADMIN_BROWSE_HOME_LIST is `.../home/:localeCode?`. react-router 6 expands an optional param
        into both `.../home/:localeCode` and `.../home`, and the second collides with this parent's
        own path -- an absolute child cannot equal its parent. Split into an index route for the
        bare case and an explicit param route for the other. */}
    <Route path={ROUTE.ADMIN_BROWSE_HOME}>
      <Route index element={<AdminBrowseHomeListPageRoute />} />
      <Route path={`${ROUTE.ADMIN_BROWSE_HOME}/:localeCode`} element={<AdminBrowseHomeListPageRoute />} />
      <Route path={ROUTE.ADMIN_BROWSE_HOME_CREATE} element={<AdminBrowseHomeCreatePageRoute />} />
      <Route path={ROUTE.ADMIN_BROWSE_HOME_EDIT} element={<AdminBrowseHomeEditPageRoute />} />
      <Route path={ROUTE.ADMIN_BROWSE_HOME_PREVIEW} element={<AdminBrowseHomePreviewPageRoute />} />
      <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
    </Route>

    <Route path={ROUTE.ADMIN_BROWSE_CATEGORIES}>
      <Route
        index
        element={<Navigate replace to={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/${DEFAULT_TOP_LEVEL_CATEGORY_ID}`} />}
      />
      <Route
        path={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/:topLevelCategoryId`}
        element={<AdminBrowseCategoriesListPageRoute basePageRoute={ROUTE.ADMIN_BROWSE_CATEGORIES} />}
      />
      <Route
        path={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/:topLevelCategoryId/:localeCode/create`}
        element={<AdminBrowseCategoriesCreatePageRoute basePageRoute={ROUTE.ADMIN_BROWSE_CATEGORIES} />}
      />
      <Route
        path={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/:topLevelCategoryId/:localeCode/:categoryConfigId`}
        element={<AdminBrowseCategoriesEditPageRoute basePageRoute={ROUTE.ADMIN_BROWSE_CATEGORIES} />}
      />
    </Route>

    {/* v6 ranks a splat below an index route, so without this the parent's OWN path matches
        the layout alone and <Outlet /> renders nothing -- an empty 200, not the 404. */}
    <Route index element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
